import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

var ThumbnailList = function ThumbnailList() {
  return import(
  /* webpackChunkName: "zoom-modal" */
  '~/components/organisms/Product/ThumbnailList.vue');
};

var SquareImage = function SquareImage() {
  return import(
  /* webpackChunkName: "zoom-modal" */
  '~/components/atoms/Product/SquareImage.vue');
};

export default {
  name: 'ZoomModal',
  components: {
    MdmModal: MdmModal,
    ThumbnailList: ThumbnailList,
    SquareImage: SquareImage
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    images: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      currentIndex: this.index,
      maxZoom: false,
      left: '0px',
      top: '0px'
    };
  },
  computed: {
    img: function img() {
      return this.images[this.currentIndex];
    },
    zoomCursor: function zoomCursor() {
      return {
        cursor: this.maxZoom ? 'zoom-out' : 'zoom-in'
      };
    }
  },
  watch: {
    currentIndex: function currentIndex(newValue) {
      if (newValue !== this.index) {
        this.$emit('update:index', newValue);
        this.resetZoom();
      }
    }
  },
  methods: {
    toggleMaxZoom: function toggleMaxZoom(ev) {
      var _this = this;

      this.maxZoom = !this.maxZoom;
      this.$nextTick(function () {
        return _this.moveZoom(ev);
      });
    },
    resetZoom: function resetZoom() {
      // Reset image position after moveZoom
      this.maxZoom = false;
      this.moveZoom();
    },
    moveZoom: function moveZoom(ev) {
      if (!this.maxZoom || !ev) {
        this.left = '0px';
        this.top = '0px';
        return;
      }

      var _this$$refs$maxZoomCo = this.$refs.maxZoomContainer,
          offsetHeight = _this$$refs$maxZoomCo.offsetHeight,
          offsetWidth = _this$$refs$maxZoomCo.offsetWidth;
      var _this$$refs$maxZoomIm = this.$refs.maxZoomImage.$el,
          clientHeight = _this$$refs$maxZoomIm.clientHeight,
          clientWidth = _this$$refs$maxZoomIm.clientWidth;
      var ratioY = ev.clientY / offsetHeight;
      var ratioX = ev.clientX / offsetWidth;
      var left = Math.round((-clientWidth + offsetWidth) * ratioX);
      var top = Math.round((-clientHeight + offsetHeight) * ratioY);
      this.left = "".concat(left, "px");
      this.top = "".concat(top, "px");
    }
  }
};